export default "__VITE_ASSET__79e69705__"